import { IClipContainer } from "./IClipContainer";

import { IGoodgameClip } from "../clip/IGoodgameClip";
import { ClipSizeComponent } from "../components/ClipSizeComponent";

import DisplayObject = createjs.DisplayObject;
import Sprite = createjs.Sprite;
import Container = createjs.Container;

export class DisplayObjectClipContainer extends Container implements IClipContainer {
    private itemDict: Map<any, any>;

    private _clipSizeComponent: ClipSizeComponent;

    private _isDisposed = false;

    constructor() {
        super();
        this.itemDict = new Map<any, any>();
        this.mouseChildren = false;
    }

    public addItem(item: IGoodgameClip, index: number = -1): void {
        this.itemDict.set(item, item);
        if (index < 0) {
            this.addChild(item.asDisplayObject());
        } else {
            this.addChildAt(item.asDisplayObject(), index);
        }
    }

    public isHit(posX: number, posY: number): boolean {
        return false;
    }

    public removeItem(itemToRemove: IGoodgameClip): void {
        if (!this.itemDict) {
            return;
        }
        if (itemToRemove) {
            itemToRemove.dispose();
            if (itemToRemove.asDisplayObject().parent == this) {
                this.removeChild(itemToRemove.asDisplayObject());
            }
        }
        this.itemDict.delete(itemToRemove);
    }

    public removeAllItems(): void {
        for (let item of Array.from(this.itemDict.values())) {
            this.removeItem(item);
        }
    }

    public dispose(): void {
        if (this._clipSizeComponent) {
            this._clipSizeComponent.destroy();
        }
        this.removeAllItems();
        this.itemDict = null;
        this._isDisposed = true;
    }

    public get isDisposed() {
        return this._isDisposed;
    }

    /**
     * @public Interface implementation. Retuns the Bitmapclip as DisplayObject
     */
    public asDisplayObject(): DisplayObject {
        return this;
    }

    public set clipSizeComponent(value: ClipSizeComponent) {
        this._clipSizeComponent = value;
    }

    public get clipSizeComponent(): ClipSizeComponent {
        return this._clipSizeComponent;
    }

    once(type: string, listener: Function, thisObject?: any, useCapture?: boolean, priority?: number): void {
    }
}
